import React from 'react'
import { useEffect, useState } from "react";
import Container from "../../../node_modules/@material-ui/core/Container";
import {  useLocation  } from "react-router-dom";

import axios from 'axios';
import { trackPromise } from 'react-promise-tracker'
import {  toast } from 'react-toastify';
import createDOMPurify from 'dompurify';

const DOMPurify = createDOMPurify(window)

const rawHTML = `
<div class="dropdown">
  <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-expanded="true">
    Dropdown
    <span class="caret"></span>
  </button>
  <ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1">
    <li role="presentation"><a role="menuitem" tabindex="-1" href="#">Action</a></li>
    <li role="presentation"><a role="menuitem" tabindex="-1" href="#">Another action</a></li>
    <li role="presentation"><a role="menuitem" tabindex="-1" href="#">Something else here</a></li>
    <li role="presentation"><a role="menuitem" tabindex="-1" href="#">Separated link</a></li>
  </ul>
</div>
`

const rawHTML2 = `
<div class="dropdown">
  <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-expanded="true">
    Dropdown
    <span class="caret"></span>
  </button>
  <ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1">
    <li role="presentation"><a role="menuitem" tabindex="-1" href="#">Something else here</a></li>
    <li role="presentation"><a role="menuitem" tabindex="-1" href="#">Separated link</a></li>
  </ul>
</div>
`

const rawHTML3 = `
<div class="dropdown">
  <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-expanded="true">
    Dropdown
    <span class="caret"></span>
  </button>
  <ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1">
    <li role="presentation"><a role="menuitem" tabindex="-1" href="#">Something else here</a></li>
    
  </ul>
</div>
`



export default function Eticket2() {
 
 
function useQuery() {
return new URLSearchParams(useLocation().search);
}


const [car,setCar] =useState(rawHTML);
  
let query = useQuery();

var pureText=query.get("ref")
  

trackPromise(axios.get(`https://www.online-cashbox.ngrok.io/eticket?ref=_BL0125YTFBR1245`))
.then(response => {
  toast.success('Your Request is submitted.')  //    sessionstorage.setItem('shop',shop)
})
.catch(error => {
  toast.error('Your Request is error')  //    sessionstorage.setItem('shop',shop)
});
    

    

 return (
  <Container component="main" maxWidth="xs">
     <div>
    { <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(car) }} /> }
  </div>
  </Container>
);
}
